import { render, staticRenderFns } from "./CostOverrun.vue?vue&type=template&id=12a38ce0"
import script from "./CostOverrun.vue?vue&type=script&lang=js"
export * from "./CostOverrun.vue?vue&type=script&lang=js"
import style0 from "./CostOverrun.vue?vue&type=style&index=0&id=12a38ce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports